/** @format */

// import React from 'react'
import React, { Component } from "react";
import {
	Container,
	Row,
	Col,
	Breadcrumb,
	BreadcrumbItem,
	Card,
	CardHeader,
	CardBody,
	CardText,
	Form,
	FormGroup,
	Label,
	Input,
	FormText,
	Button,
} from "reactstrap";
import Header from "../components/LoginHeader";
import Footer from "../components/LoginFooter";
import { Parallax } from "react-parallax";

class ThankYou extends Component {

	constructor(props) {
		super(props);
		this.state = {
		}
	}
	componentDidMount() {
		document.title = "Thank you"; //Change title of the page
	}
	render() {
		return (
			<React.Fragment>
				<Header />
				<Parallax
					className='hero hero-image light-overlay'
					bgImage='/img/photo/thankyou.jpg'
					bgImageStyle={{
						top: "-15%",
						height: "calc(100% + 130px)",
						objectFit: "cover",
						width: "100%",
					}}
					strength={700}
				>
					<Container className='overlay-content'>
						<div className='hero-content'>
							<h1 className='hero-heading'>Thank You For Registering</h1>
							<p className='ml-3 text-dark'>
								You'll recieve an email from us shortly.
							</p>
						</div>
					</Container>
				</Parallax>
				<section className='py-6'>
					<Container>
						<Row>
							<Col md='4' className='text-center text-md-left mb-4 mb-md-0'>
								<h4>Address</h4>
								<p className='text-muted'>
									61 Greenpoint Ave Suite 631
									<br />
									Brooklyn
									<br />
									NY 11222, <strong>USA</strong>
								</p>
							</Col>
							<Col md='4' className='text-center text-md-left mb-4 mb-md-0'>
								<h4>Call us</h4>

								<p className='text-muted'>
									<strong>(800) 631-0630</strong>
								</p>
							</Col>
							<Col md='4' className='text-center text-md-left mb-4 mb-md-0'>
								<h4>Electronic support</h4>
								<p className='text-muted'>
									Please feel free to write an email to us.
								</p>
								<ul className='list-unstyled text-muted'>
									<li>info@brooklynbicycleco.com</li>
								</ul>
							</Col>
						</Row>
					</Container>
				</section>

				<Footer loginFooterResize={true} />
			</React.Fragment>
		);
	}
}

export default ThankYou;
